import styled from 'styled-components';

export const FooterStyled = styled.footer`
  bottom: 0;
  font-size: 12px;
  padding: 20px;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export const CookiePolicy = styled.p`
  text-align: right;

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default FooterStyled;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.styled.js